import {
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { MdFeedback } from "react-icons/md";
import { useEffect, useState } from "react";
import TooltipIconButton from "components/Shared/TooltipIconButton";
import { navBarTooltipIconButtonProps } from "components/Layout/NavBar/TooltipIconLinkButton";
import { asyncVoid } from "utils/asyncVoidHandler";
import { useCurrentUserData } from "utils/currentUserHooks";
import { usePatchCurrentUserMetadata } from "utils/usePatchUserMetadata";
import { openFeedbackForm } from "utils/userbackContext";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";

const USERBACK_POPOVER_METADATA_KEY = "hasSeenUserbackFeedbackPopover";

export default function FeedbackButton() {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const patchCurrentUserMetadata = usePatchCurrentUserMetadata();

  const { showErrorToast } = useAsyncCompleteToast();

  const userData = useCurrentUserData();
  const { id: userId, metadata: userMetadata = {} } = userData || {};
  const hasSeenFeedbackPopover =
    userMetadata?.[USERBACK_POPOVER_METADATA_KEY] === true;

  useEffect(() => {
    if (!userId || hasSeenFeedbackPopover || isPopoverOpen) return;
    const timeout = window.setTimeout(() => {
      setIsPopoverOpen(true);
    }, 500);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [userId, hasSeenFeedbackPopover, isPopoverOpen]);

  const closePopover = () => {
    setIsPopoverOpen(false);
    if (userId && !hasSeenFeedbackPopover) {
      asyncVoid(
        patchCurrentUserMetadata({ [USERBACK_POPOVER_METADATA_KEY]: true }),
      );
    }
  };

  return (
    <Popover
      isOpen={isPopoverOpen}
      onClose={closePopover}
      placement="bottom"
      closeOnBlur
      closeOnEsc
    >
      <PopoverTrigger>
        <TooltipIconButton
          label="Send Feedback"
          icon={<Icon as={MdFeedback} />}
          {...navBarTooltipIconButtonProps}
          onClick={() => {
            openFeedbackForm().catch(showErrorToast);
          }}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="16rem" fontSize="sm">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody lineHeight="normal" textAlign="center" pr={10}>
            Have a question, suggestion, or want to report an issue? Share your
            feedback with us here!
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
